// extracted by mini-css-extract-plugin
export default {"copy":"Copy_copy__jOeBq"};